// 9fbef606107a605d69c0edbcd8029e5d
export const getLoyaltyTierBenefits = (state) => {
  return (
    state?.LoyaltyPlaceRewardsReducer &&
    state?.LoyaltyPlaceRewardsReducer?.get('loyaltyTierBenefits')
  );
};

export const getLoyaltyTierBenefitJson = (state) => {
  return (
    state?.LoyaltyPlaceRewardsReducer &&
    state?.LoyaltyPlaceRewardsReducer?.get('loyaltyTierBenefitsJson')
  );
};

export const getNewLoyaltyTierBenefitJson = (state) => {
  return (
    state?.LoyaltyPlaceRewardsReducer &&
    state?.LoyaltyPlaceRewardsReducer?.get('newLoyaltyTierBenefitsJson')
  );
};

export const getTierBenefitsModuleContent = (state) => {
  return (
    state?.LoyaltyPlaceRewardsReducer &&
    state.LoyaltyPlaceRewardsReducer?.get('tierBenefitsModuleContent')
  );
};

export const getEarlyAccessProducts = (state) => {
  return (
    state?.LoyaltyPlaceRewardsReducer &&
    state.LoyaltyPlaceRewardsReducer?.get('earlyAccessProducts')
  );
};
